import { lightTheme } from "../../../theme/theme";
type Theme = typeof lightTheme;

export const DetailedCardStyles = (theme: Theme) => {
  const accent = `var(--accent, ${theme.primary})`;

  return {
    // Hover (with GlobalStyles.card base)
    cardHover: {
      transform: "translateY(-4px)",
      boxShadow: "0 14px 30px rgba(0,0,0,.12)",
      borderColor: `${accent}55`,
    },

    // Media
    previewWrap: {
      position: "relative" as const,
      overflow: "hidden",
      aspectRatio: "16 / 9",
      background: `${accent}0F`,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
    preview: {
      width: "100%",
      height: "100%",
      objectFit: "cover" as const,
      display: "block",
      transform: "scale(1)",
      transition: "transform .5s ease",
    },
    previewHover: { transform: "scale(1.06)" },
    previewMask: {
      content: '""',
      position: "absolute" as const,
      inset: 0,
      background:
        "linear-gradient(180deg, rgba(0,0,0,0.00) 55%, rgba(0,0,0,0.08) 100%)",
      pointerEvents: "none" as const,
    },

    // Placeholder shown when no image is provided
    previewPlaceholder: {
      width: "100%",
      height: "100%",
      background:
        "linear-gradient(180deg, rgba(0,0,0,0.03) 0%, rgba(0,0,0,0.06) 100%)",
    },

    // Body
    body: {
      padding: 16,
      display: "flex",
      flexDirection: "column" as const,
      gap: 10,
      borderRadius: 10,
    },

    // Title
    cardTitle: {
      fontFamily: "'Poppins', sans-serif",
      fontWeight: 800,
      fontSize: 18,
      lineHeight: 1.25,
      letterSpacing: 0.2,
      color: theme.text,
    },

    // Meta row
    metaRow: {
      display: "flex",
      gap: 8,
      flexWrap: "wrap" as const,
      fontSize: 13,
      color: theme.text2,
      alignItems: "center",
    },

    // Blurb
    blurb: {
      fontSize: 14,
      opacity: 0.95,
      lineHeight: 1.55,
      color: theme.text,
    },

    // Stats (pills)
    statsRow: {
      display: "flex",
      flexWrap: "wrap" as const,
      gap: 8,
      marginTop: 4,
    },
    statPill: {
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      padding: "6px 0px",
      borderRadius: 999,
      border: `1px solid ${accent}33`,
      background: `${accent}0F`,
      fontSize: 12,
      fontWeight: 600,
      color: theme.text,
      whiteSpace: "nowrap" as const,
    },
  } as const;
};
